module.exports = __webpack_public_path__ + "assets/img/downLoadLbg.2c10178b.png";